// removed by extract-text-webpack-plugin
module.exports = {"flier-container":"flier__flier-container__3EmuG","flier-container-zoom":"flier__flier-container-zoom__3tn9H flier__flier-container__3EmuG","flier":"flier__flier__3QJuA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/flier.scss
// module id = 1250
// module chunks = 1